import React from 'react';
import { FaShieldAlt } from 'react-icons/fa';
import { GUARANTEE_ITEMS } from '../utils/trustBadges';
import { GuaranteeIcon } from './TrustBadge';
import './BookStayGuarantee.css';

const BookStayGuarantee = ({ variant = 'full', className = '' }) => {
  if (variant === 'compact') {
    return (
      <div className={`book-stay-guarantee book-stay-guarantee--compact ${className}`}>
        <FaShieldAlt className="book-stay-guarantee__shield" aria-hidden="true" />
        <div>
          <strong>UBSAAPP Book &amp; Stay Guarantee</strong>
          <p>Verified listing · Real photos · No hidden charges · 24×7 support</p>
        </div>
      </div>
    );
  }

  return (
    <section className={`book-stay-guarantee ${className}`} aria-labelledby="book-stay-guarantee-title">
      <div className="book-stay-guarantee__header">
        <div className="book-stay-guarantee__icon-wrap">
          <FaShieldAlt className="book-stay-guarantee__shield" aria-hidden="true" />
        </div>
        <div>
          <h2 id="book-stay-guarantee-title" className="book-stay-guarantee__title">
            UBSAAPP Book &amp; Stay Guarantee
          </h2>
          <p className="book-stay-guarantee__subtitle">
            Book with confidence — every guarantee is designed to protect your stay from search to checkout.
          </p>
        </div>
      </div>

      <div className="book-stay-guarantee__grid">
        {GUARANTEE_ITEMS.map((item) => (
          <article key={item.id} className="book-stay-guarantee__card">
            <div className="book-stay-guarantee__card-icon">
              <GuaranteeIcon id={item.id} />
            </div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default BookStayGuarantee;
